import Swiper from 'swiper'
import {Navigation, Thumbs} from 'swiper'
import {initElements, playVideo} from '../define/shared'

Swiper.use([Navigation, Thumbs])

export default function initMediaGalleryBlocks() {
    initElements('.wab.wab-mediaGallery', initMediaGalleryBlock)
}

/**
 * @param {HTMLElement} root
 */
export function initMediaGalleryBlock(root) {
    const fwSliderEl = root.querySelector('.sw-slider')
    const thumbSliderEl = root.querySelector('.b-thumbs')
    const [prevSlideBtnEl, nextSlideBtnEl] =
        [root.querySelector('.swiper-button-prev'), root.querySelector('.swiper-button-next')]
    let thumbSlider = null

    const videoHandlers = []

    initElements({ root, selector: '.b-video' }, videoEl => {
        const [ videoId, provider ] = [videoEl.dataset.id, videoEl.dataset.provider]
        const btn = videoEl.querySelector('.b-video-playBtn')
        const container = videoEl.querySelector('.b-video-inner')

        if (provider && videoId) {
            btn.addEventListener('click', event => {
                videoEl.classList.add('is--initialized')
                playVideo(container, {
                    videoId: videoEl.dataset.id,
                    provider: videoEl.dataset.provider,
                    background: false,
                }).then(handler => {
                    videoHandlers.push(handler)
                })
            }, { once: true })
        }
    })

    initElements({ root, selector: '.b-slideInfo' }, (slideInfoEl, idx) => {
        const captionEl = slideInfoEl.querySelector('.i-caption')
        const descrEl = slideInfoEl.querySelector('.i-descr')
        const descrBtnEl = slideInfoEl.querySelector('.i-descrBtn')

        let popupEl = null
        let transitioning = false

        if (descrEl && descrBtnEl) {
            descrBtnEl.addEventListener('click', event => {
                event.preventDefault()
                togglePopup()
            })
            window.addEventListener('resize', onResize)
            window.addEventListener('orientationchange', onResize)
            window.addEventListener('beforeunload', hidePopup)
        }

        function onResize() {
            if (window.innerWidth >= 768) {
                hidePopup()
            }
        }

        function togglePopup() {
            popupEl && popupEl.parentElement ? hidePopup() : showPopup()
        }

        function showPopup() {
            if (transitioning) {
                return
            }
            if (!popupEl) {
                initPopup()
            }
            document.body.appendChild(popupEl)
            transitioning = true
            setTimeout(() => {
                popupEl.classList.add('is--visible')
                setTimeout(() => {
                    transitioning = false
                }, 350)
            }, 10)
        }

        function hidePopup() {
            if (transitioning || !popupEl || !popupEl.parentElement) {
                return
            }
            transitioning = true
            popupEl.classList.remove('is--visible')
            setTimeout(() => {
                popupEl.parentElement.removeChild(popupEl)
                transitioning = false
            }, 350)
        }

        function initPopup() {
            popupEl = Object.assign(document.createElement('div'), {
                className: 'mgPopup',
            })
            popupEl.style.transition = `0.32s ease-in-out`
            const closeBtn = Object.assign(document.createElement('button'), {
                innerHTML: `<span class="icon icon-close"></span>`,
                className: 'mgPopup-closeBtn',
            })
            const backdropEl = popupEl.appendChild(Object.assign(document.createElement('div'), {
                className: 'mgPopup-backdrop',
            }))
            const innerEl = popupEl.appendChild(Object.assign(document.createElement('div'), {
                className: 'mgPopup-inner',
            }))
            if (captionEl) {
                innerEl.appendChild(Object.assign(document.createElement('h2'), {
                    innerHTML: captionEl.innerHTML,
                    className: 'mgPopup-caption',
                }))
            }
            innerEl.appendChild(Object.assign(document.createElement('div'), {
                innerHTML: descrEl.innerHTML,
                className: 'mgPopup-content wysiwyg-content',
            }))
            popupEl.appendChild(backdropEl)
            popupEl.appendChild(closeBtn)
            ;[].slice.apply(popupEl.querySelectorAll('[data-reveal]')).forEach(el => {
                el.removeAttribute('data-reveal')
            })
            backdropEl.addEventListener('click', hidePopup)
            closeBtn.addEventListener('click', hidePopup)
        }
    })

    if (thumbSliderEl) {
        thumbSliderEl.addEventListener('click', event => {
            event.preventDefault()
        })
        const slidesArr = [].slice.apply(thumbSliderEl.querySelectorAll('.b-slide'))
        thumbSlider = new Swiper(thumbSliderEl, {
            loop: true,
            centerInsufficientSlides: true,
            slidesPerView: 4,
            spaceBetween: 20,
            breakpoints: {
                900: {
                    slidesPerView: 4,
                },
                720: {
                    slidesPerView: 3,
                },
                480: {
                    enabled: 2,
                },
            },
        })
    }

    const mainSliderArgs = {
        loop: true,
        navigation: {
            prevEl: prevSlideBtnEl,
            nextEl: nextSlideBtnEl,
        },
    }

    if (thumbSlider) {
        mainSliderArgs.thumbs = {
            swiper: thumbSlider,
            autoScrollOffset: 1,
            multipleActiveThumbs: false,
            slideThumbActiveClass: 'is--active',
        }
    }

    const mainSlider = new Swiper(fwSliderEl, mainSliderArgs)
    mainSlider.on('slideChange', event => {
        videoHandlers.forEach(handler => handler.pause())
    })
}
